module.exports = __webpack_public_path__ + "img/order-step6-b.046bb36d.png";